import type { IconSvgObject } from './types';

const GitPullRequestCreateArrowIcon: IconSvgObject = [
  ["path", { d: "M5 9C6.65685 9 8 7.65685 8 6C8 4.34315 6.65685 3 5 3C3.34315 3 2 4.34315 2 6C2 7.65685 3.34315 9 5 9Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 13V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 6H14C15.8692 6 16.8038 6 17.5 6.40192C17.9561 6.66523 18.3348 7.04394 18.5981 7.5C19 8.19615 19 9.13077 19 11M15 3C15 3 12 5.20944 12 6C12 6.79056 15 9 15 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M19 15V21M22 18H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default GitPullRequestCreateArrowIcon;
